import apiClient from './apiClient'

export interface RoleRef {
  role_id: number
  name: string
  description: string | null
}

export interface UserWithRoles {
  email: string
  roles: RoleRef[]
}

export const getRoles = async (): Promise<RoleRef[]> => {
  const response = await apiClient.get<RoleRef[]>('/roles')
  return response.data
}

export const getUsers = async (): Promise<UserWithRoles[]> => {
  const response = await apiClient.get<UserWithRoles[]>('/users')
  return response.data
}

// Register a new user by email (their Microsoft UPN) and grant roles in one step.
export const createUser = async (
  email: string,
  roleIds: number[]
): Promise<UserWithRoles> => {
  const response = await apiClient.post<UserWithRoles>('/users', {
    email,
    role_ids: roleIds,
  })
  return response.data
}

// A role assignment is the resource /users/{email}/roles/{roleId}:
// PUT makes it exist (idempotent), DELETE removes it.
const roleUrl = (email: string, roleId: number): string =>
  `/users/${encodeURIComponent(email)}/roles/${roleId}`

export const assignRole = async (
  email: string,
  roleId: number
): Promise<void> => {
  await apiClient.put(roleUrl(email, roleId))
}

export const removeRole = async (
  email: string,
  roleId: number
): Promise<void> => {
  await apiClient.delete(roleUrl(email, roleId))
}
